import Inspector from './inspector';
import PinIcon from '../../../images/PinIcon';

const { InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { variant, margin } = attributes;

  const placeholderImage = 'https://via.placeholder.com/52x64';

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className={`locate-selector ${variant} ${margin}`}>
        <InnerBlocks
          template={[
            [
              'app/search-bar',
              {
                containerized: false,
                titleVariant: 'text',
                titleColor: 'color-white',
                titleMargin: 'margin-extra-small',
                variant: 'white',
                placeholder: 'Digite sua cidade',
                useIn: 'locations',
              },
            ],
            ['app/list-cities'],
          ]}
        />

        <div className={`Card-col-item locate margin-none`}>
          <PinIcon />

          <div className="Card-col-item-text">
            <p className="Typography title-5 left color-white margin-none">
              Os endereços devem ser cadastrados no painel
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit;
